import React from 'react';
import Hero from '@/components/Home/Hero';
import EditorialMarquee from '@/components/Home/Marquee';
import Manifesto from '@/components/Home/Manifesto';
import FestivalTours from '@/components/Home/FestivalTours';
import WeeklyTours from '@/components/Home/WeeklyTours';
import AboutAli from '@/components/Home/AboutAli';
import Reviews from '@/components/Home/Reviews';
import Contacts from '@/components/Home/Contacts';
import SiteSEO from '@/components/SiteSEO';

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <SiteSEO path="/" />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <AboutAli />
      <FestivalTours />
      <WeeklyTours />
      <Reviews />
      <Contacts />
    </div>
  );
}
